import React, { useEffect, useState } from "react";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import RestService from "./../../Restservice";
import ReactHtmlParser from "react-html-parser";
import PremiumSlider from "./PremiumSlider";
import { Link } from "react-router-dom";
import Common from "./../../common.json";

export default function PremiumServicesPage() {
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState({});

  useEffect(() => {
    setLoading(true);
    RestService.getpremiumData(function (res) {
      setLoading(false);
      const response = JSON.parse(res);
      setglobaldata(response.data);
    });
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}

      <GlobalHelmet {...Common?.premium} />
      <div className="bodycontainer">
        <div className="auto-space">
          <Breadcrumbs page="Premium Services" />
          <div className="row">
            <div className="col-md-12 ">
              <h1 className="highlighttext">Premium Services </h1>
              <p>
                Find the different types of Money Tree Robo premium services for
                Indian stock market. Pro+ services includes Pre-market screener,
                Fundamental Stock Screener, Indicator stock screener, Auto
                signal, EOD stock screener, Stock signal, Stock signal alert for
                NSE stocks
              </p>
            </div>
          </div>
          <div className="signalheader">
            {globaldata.premiumData
              ? globaldata.premiumData.map((item, key) => (
                  <div className="row" key={key}>
                    {/* <div className="col-md-12 "> <hr /> </div> */}
                    <div className="col-md-6 ">
                      <h3>{item.title} </h3>
                      {ReactHtmlParser(item.description)}
                      <div className="d-flex justify-content-between total font-weight-bold mt-4">
                        <span>
                          <Link
                            to="/subscription"
                            target="_blank"
                            className="btn btn-success"
                          >
                            Pay Now
                          </Link>
                        </span>
                        {/* <span>$7,197.00</span> */}
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <PremiumSlider image={item.image} />
                    </div>
                  </div>
                ))
              : ""}
          </div>
        </div>
      </div>
    </>
  );
}
